import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "../components/Navbars/OperadorNavBar.jsx";
import AdminFooter from "../components/Footers/Footer.jsx";
import { api_GET } from "../services/api_service.js";
import { getSessionCookie, getTokenCookie } from "../services/session.js";
import routes from "../routes-operador.jsx";

import { Chat } from "constants/chat";

class Operador extends React.Component {

  componentDidMount() {
    Chat();
  }

  componentDidUpdate(e) {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.mainContent.scrollTop = 0;
    this.validaPermissaoAcesso();
  }

  validaPermissaoAcesso = () => {
    let session = getSessionCookie();
    var token = getTokenCookie();

    if (session === null || token === null) {
      this.props.history.push("/auth/login");
      return false;
    }

    if (token.expired) {
      this.props.history.push("/auth/login");
      return false;
    }

    if (this.props.history.location.pathname == "/operador/dashboard" || this.props.history.location.pathname == "/operador/trocarsenha")
      return;

    if (session.perfil == "Master")
      return;

    if (session.perfil != "Encarregado de Monitoramento") {
      this.props.history.push('/auth/login');
      return;
    }

    api_GET(`usuario/GetPermissaoAcesso/${session.usuarioId}/${this.props.history.location.pathname.split("/")[2]}`).then(result => {
      if (result.status !== 200) {
        this.props.history.push("/operador/trocarsenha");
      }
      else if (result.data == null) {
        this.props.history.push("/operador/trocarsenha");
      }
    });
  }

  getRoutes = routes => {
    this.validaPermissaoAcesso();

    return routes.map((prop, key) => {
      if (prop.layout === "/operador") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  getBrandText = path => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
  render() {
    return (
      <>

        <div className="main-content" ref="mainContent">
          <AdminNavbar
            {...this.props}
            brandText={this.getBrandText(this.props.location.pathname)}
          />
          <Switch>
            {this.getRoutes(routes)}
            <Redirect from="*" to="/operador/trocarsenha" />
          </Switch>
          <Container fluid>
            <AdminFooter />
          </Container>
        </div>
      </>
    );
  }

}

export default Operador;
